import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import MainPanel from '../components/main-panel/main-panel';
import NoAccess from '../components/no-access/no-access';
import { selectCurrentUser } from 'src/modules/users/selector';
import { fetchSettingsRequest } from '../store/settings/settings';
import { useEffect } from 'react';

const Vpo = () => {

  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => selectCurrentUser(state));

  const isNoAccess = !user.infoVPO.user && !user.infoVPO.admin && !user.infoVPO.zone && !user.infoVPO.adminRegion;

   useEffect(() => {
     dispatch(fetchSettingsRequest());
 }, [dispatch]);

  if (isNoAccess && user.displayName) return <NoAccess />;

  return (
    <MainPanel />
  )
};

export default Vpo;
